import { useState, useEffect } from 'react';

type QualtricsIntercept = {
	passed: boolean;
	createSurveyLink: (surveyLink: string, embeddedData: Record<string, any>) => string;
};

const noop: QualtricsIntercept['createSurveyLink'] = () => '';

export const useQualtricsIntercept = (interceptId?: string, enabled = true): QualtricsIntercept => {
	const [intercept, setIntercept] = useState<QualtricsIntercept>({
		passed: false,
		createSurveyLink: noop,
	});

	useEffect(() => {
		if (!enabled || typeof window === 'undefined') return;
		if (intercept.passed) return;
		if (!interceptId) return;

		const win = window as typeof window & { FS?: any };

		let retryHandle: number | undefined;
		let cancelled = false;

		const runInterceptCheck = () => {
			if (!win.FS?.Qualtrics) {
				return;
			}

			win.FS.Qualtrics.hasInterceptPassed(interceptId)
				.then((result: QualtricsIntercept) => {
					if (!cancelled && result?.passed) {
						setIntercept(result);
					}
				})
				.catch((error: Error) => {
					console.log('Failed to get itinerary survey', error);
				});
		};

		if (win.FS?.Qualtrics) {
			runInterceptCheck();
		} else {
			retryHandle = window.setInterval(() => {
				if (win.FS?.Qualtrics) {
					clearInterval(retryHandle);
					retryHandle = undefined;
					runInterceptCheck();
				}
			}, 500);
		}

		return () => {
			cancelled = true;
			if (retryHandle) {
				clearInterval(retryHandle);
			}
		};
	}, [interceptId, enabled, intercept.passed]);

	return intercept;
};
